import useFetch from 'app/hooks/useFetch'
import usePermissionButton from 'app/hooks/usePermissionButton'
import {FC, useCallback} from 'react'
import {useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import {LunchGridProps} from './LunchGrid'

const HeadLunchGrid: FC<LunchGridProps> = (props) => {
  const navigate = useNavigate()

  const {isValid} = usePermissionButton()

  return (
    <div className='input-group'>
      <div className='container'>
        <div className='row'>
          <div className='col col-info'>
            <div className='item-info'>
              <a
                className='btn btn-secondary btn-sm'
                href='#'
                onClick={props.getLeyend}
                data-tip
                data-for='leyenda'
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='30'
                  height='30'
                  fill='#2A2889'
                  className='bi bi-palette'
                  viewBox='0 0 16 16'
                >
                  <path d='M8 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm4 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM5.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z' />
                  <path d='M16 8c0 3.15-1.866 2.585-3.567 2.07C11.42 9.763 10.465 9.473 10 10c-.603.683-.475 1.819-.351 2.92C9.826 14.495 9.996 16 8 16a8 8 0 1 1 8-8zm-8 7c.611 0 .654-.171.655-.176.078-.146.124-.464.07-1.119-.014-.168-.037-.37-.061-.591-.052-.464-.112-1.005-.118-1.462-.01-.707.083-1.61.704-2.314.369-.417.845-.578 1.272-.618.404-.038.812.026 1.16.104.343.077.702.186 1.025.284l.028.008c.346.105.658.199.953.266.653.148.904.083.991.024C14.717 9.38 15 9.161 15 8a7 7 0 1 0-7 7z' />
                </svg>
              </a>
              <ReactTooltip id='leyenda' place='top' type='success' effect='solid'>
                Ver Leyenda
              </ReactTooltip>
              {(!props.isMinutaVertical || !props.isMinutaHorizontal) && (
                <>
                  {props.isMinutaFood && (
                    <>
                      <a
                        className='btn btn-secondary btn-sm'
                        href='#'
                        onClick={props.resumeDetalle}
                        data-tip
                        data-for='ocultar'
                        id='ocultar_todo'
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='30'
                          height='30'
                          fill='#2A2889'
                          className='bi bi-zoom-out'
                          viewBox='0 0 16 16'
                          
                        >
                          <path
                            fillRule='evenodd'
                            d='M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z'
                          />
                          <path d='M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z' />
                          <path
                            fillRule='evenodd'
                            d='M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z'
                          />
                        </svg>
                      </a>
                      <ReactTooltip id='ocultar' place='top' type='info' effect='solid'>
                        Ocultar
                      </ReactTooltip>

                      <a
                        className='btn btn-secondary btn-sm'
                        href='#'
                        onClick={props.openDetalle}
                        data-tip
                        data-for='mostrar'
                        id='mostrar_todo'
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='30'
                          height='30'
                          fill='#2A2889'
                          className='bi bi-zoom-in'
                          viewBox='0 0 16 16'
                          
                        >
                          <path
                            fillRule='evenodd'
                            d='M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z'
                          />
                          <path d='M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z' />
                          <path
                            fillRule='evenodd'
                            d='M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z'
                          />
                        </svg>
                      </a>
                      <ReactTooltip id='mostrar' place='top' type='info' effect='solid'>
                        Mostrar
                      </ReactTooltip>
                    </>
                  )}
                </>
              )}
              <div className='form-check form-check-inline'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  id='inlineCheckbox1'
                  defaultChecked={!props.normal}
                  onChange={props.getNormal}
                ></input>
                <label className='form-check-label' htmlFor='inlineCheckbox1'>
                  Normal
                </label>
              </div>
              <div className='form-check form-check-inline'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  id='inlineCheckbox2'
                  value='option2'
                  onChange={props.getIcono}
                ></input>
                <label className='form-check-label' htmlFor='inlineCheckbox2'>
                  Ícono
                </label>
              </div>
              <div className='form-check form-check-inline'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  id='inlineCheckbox3'
                  value='option3'
                  onChange={props.getColor}
                ></input>
                <label className='form-check-label' htmlFor='inlineCheckbox3'>
                  Color
                </label>
              </div>
              {(!props.isMinutaVertical || !props.isMinutaHorizontal) && (
                <div className='form-check form-check-inline'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    id='inlineCheckbox4'
                    value='option4'
                    onChange={props.getPrecio}
                  ></input>
                  <label className='form-check-label' htmlFor='inlineCheckbox4'>
                    Precio
                  </label>
                </div>
              )}
            </div>
            {/* leyenda */}
            {props.showLeyend && (
              <div className='item-info'>
                {/* <table className='table table-hover table-leyenda'>
                  <h5>Iconografía minuta</h5>
                  <tbody>
                    <tr>
                      <td className='color normal'>
                        Día Normal<div></div>
                      </td>
                      <td className='color fin-de-semana'>
                        Fin de semana
                        <div></div>
                      </td>
                      <td className='color receta-fija-color'>
                        Receta Fija<div></div>
                      </td>
                      <td className='color desc-ultimo-cambio'>
                        Último cambio realizado<div></div>
                      </td>
                    </tr>
                  </tbody>
                </table> */}
                <div className='container-tabla-icon'>
                  <div className='item-tabla'>
                    <p>Día Normal</p>
                    <div className='normal'></div>
                  </div>
                  <div className='item-tabla'>
                    <p>Fin de semana</p>
                    <div className='feriado'></div>
                  </div>
                  <div className='item-tabla'>
                    <p>Receta fija</p>
                    <div className='fin-de-semana'></div>
                  </div>
                  <div className='item-tabla'>
                    <p>Último cambio realizado</p>
                    <div className='receta-fija-color'></div>
                  </div>
                </div>
              </div>
            )}
            {/* end leyenda */}
          </div>

          <div className='col col-info'>
            <div className='item-info'>
              {(!props.isMinutaVertical || !props.isMinutaHorizontal) && props.showPrintIcon &&
                isValid('imprimir_minuta') && (
                  <>
                    <a className='btn btn-secondary btn-sm' href='#' data-tip data-for='asdf'>
                      <img
                        src={'/amd-sodexo/media/icons/minutas/acrobat.svg'}
                        alt='Imprimir Minuta'
                      />
                    </a>
                    <ReactTooltip id='asdf' place='top' type='error' effect='solid'>
                      {props.textPdf ? props.textPdf : 'Imprimir Minuta'}
                    </ReactTooltip>
                  </>
                )}
              {isValid('imprimir_minuta_cliente') && props.showPrintClientIcon && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='imp-minuta-cliente'
                  >
                    <img
                      src={'/amd-sodexo/media/icons/minutas/pdfDocument.svg'}
                      alt='Imprimir Minuta Cliente'
                    />
                  </a>
                  <ReactTooltip id='imp-minuta-cliente' place='top' type='error' effect='solid'>
                    {props.textPdfClient ? props.textPdfClient : 'Imprimir Minuta Cliente'}
                  </ReactTooltip>
                </>
              )}
              {(!props.isMinutaVertical || !props.isMinutaHorizontal) && props.showExportIcon &&
                isValid('exportar_minuta') && (
                  <>
                    <a
                      className='btn btn-secondary btn-sm'
                      href='#'
                      data-tip
                      data-for='e-minuta'
                      onClick={props.onExport || undefined}
                    >
                      <img
                        src={'/amd-sodexo/media/icons/minutas/fileEarmark.svg'}
                        alt='Exportar Minuta'
                      />
                    </a>
                    <ReactTooltip id='e-minuta' place='top' type='success' effect='solid'>
                      {props.textExcel ? props.textExcel : 'Exportar Minuta'}
                    </ReactTooltip>
                  </>
                )}
              {isValid('exportar_minuta_cliente') && props.showExportClientIcon && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='exp-minuta-cliente'
                    onClick={props.onExportClient || undefined}
                  >
                    <img
                      src={'/amd-sodexo/media/icons/minutas/fileEarmarkExcel.svg'}
                      alt='Exportar Minuta Cliente'
                    />
                  </a>
                  <ReactTooltip id='exp-minuta-cliente' place='top' type='success' effect='solid'>
                    {props.textExcelClient ? props.textExcelClient : 'Exportar Minuta Cliente'}
                  </ReactTooltip>
                </>
              )}
              {isValid('exportar_minuta_cliente') && props.showExportClientIcon2 &&(
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='exp-minuta-cliente2'
                    onClick={props.onExportClient2 || undefined}
                  >
                    <img
                      src={'/amd-sodexo/media/icons/minutas/fileEarmarkExcel.svg'}
                      alt='Exportar Minuta Cliente 2'
                    />
                  </a>
                  <ReactTooltip id='exp-minuta-cliente2' place='top' type='success' effect='solid'>
                    {props.textExcelClient ? props.textExcelClient : 'Exportar Minuta Cliente 2'}
                  </ReactTooltip>
                </>
              )}
              {isValid('deshacer') && props.showUndo && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    onClick={props.undo || undefined}
                    data-tip
                    data-for='deshacer1'
                  >
                    <img
                      src={'/amd-sodexo/media/icons/minutas/arrowLeftShort.svg'}
                      alt='Deshacer'
                    />
                  </a>
                  <ReactTooltip id='deshacer1' place='top' type='warning' effect='solid'>
                    Deshacer
                  </ReactTooltip>
                </>
              )}
              {isValid('deshacer_todo') && props.showUndoAll && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='deshacer-todo1'
                    onClick={props.undoAll || undefined}
                  >
                    <img
                      src={'/amd-sodexo/media/icons/minutas/arrowCounterClockWise.svg'}
                      alt='Deshacer Todo'
                    />
                  </a>
                  <ReactTooltip id='deshacer-todo1' place='top' type='dark' effect='solid'>
                    Deshacer Todo
                  </ReactTooltip>
                </>
              )}
              {props.showSave && isValid('guardar') && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='guardar1'
                    onClick={props.onSave || undefined}
                  >
                    <img
                      src={'/amd-sodexo/media/icons/minutas/clipboard2Check.svg'}
                      alt='Guardar'
                    />
                  </a>
                  <ReactTooltip id='guardar1' place='top' type='info' effect='solid'>
                    Guardar
                  </ReactTooltip>
                </>
              )}
              {props.showSave && isValid('guardar_y_enviar') && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='guardar-enviar1'
                    onClick={props.onSaveSend || undefined}
                  >
                    <img
                      src={'/amd-sodexo/media/icons/minutas/biCursor.svg'}
                      alt='Guardar y enviar'
                    />
                  </a>
                  <ReactTooltip id='guardar-enviar1' place='top' type='info' effect='solid'>
                    Guardar y enviar
                  </ReactTooltip>
                </>
              )}
              {isValid('informacion') && (
                <>
                  <a
                    onClick={props.information}
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='information-1'
                  >
                    <img src={'/amd-sodexo/media/icons/minutas/infoCircle.svg'} alt='Información' />
                  </a>
                  <ReactTooltip id='information-1' place='top' type='info' effect='solid'>
                    Información
                  </ReactTooltip>
                </>
              )}
              {isValid('replicar') && props.showReplyAll && (
                <>
                  <a
                    onClick={props.replyAll}
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='reply-all-1'
                  >
                    <img src={'/amd-sodexo/media/icons/minutas/replyAll.svg'} alt='Replicar' />
                  </a>
                  <ReactTooltip id='reply-all-1' place='top' type='info' effect='solid'>
                    Replicar
                  </ReactTooltip>
                </>
              )}
              {isValid('replicar_minuta_fija') && props.showReplicateMinutaFija && (
                <>
                  <a
                    onClick={props.onReplicateMinutaFija}
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='reply-minuta'
                  >
                    <img
                      src={'/amd-sodexo/media/icons/minutas/replicarMinutaFija.svg'}
                      alt='Replicar Minuta Fija'
                    />
                  </a>
                  <ReactTooltip id='reply-minuta' place='top' type='info' effect='solid'>
                    Replicar Minuta Fija
                  </ReactTooltip>
                </>
              )}
              {isValid('replicar_minuta_fija') && props.showReplicateMinuta && (
                <>
                  <a
                    onClick={props.onReplicateMinuta}
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='reply-minuta'
                  >
                    <img
                      src={'/amd-sodexo/media/icons/minutas/replicarMinutaFija.svg'}
                      alt='Replicar Minuta Fija'
                    />
                  </a>
                  <ReactTooltip id='reply-minuta' place='top' type='info' effect='solid'>
                    Replicar Minuta
                  </ReactTooltip>
                </>
              )}
              {isValid('replicar_minuta_seguidor') && (
                <>
                  <a
                    onClick={props.onReplicateMinutaFollower}
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='reply-follower'
                  >
                    <img
                      src={'/amd-sodexo/media/icons/minutas/replyAllFill.svg'}
                      alt='Publicar Minuta Seguidores'
                    />
                  </a>
                  <ReactTooltip id='reply-follower' place='top' type='info' effect='solid'>
                    Publicar Minuta Seguidores
                  </ReactTooltip>
                </>
              )}
              {isValid('homologar') && props.showHomologate && (
                <>
                  <a
                    onClick={props.onHomologate}
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='homologate'
                  >
                    <img src={'/amd-sodexo/media/icons/minutas/homologate.svg'} alt='Homologar' />
                  </a>
                  <ReactTooltip id='homologate' place='top' type='info' effect='solid'>
                    Homologar
                  </ReactTooltip>
                </>
              )}
              {isValid('redistribucion_minuta') && props.showMinuteRedistribution && (
                <>
                  <a
                    onClick={props.onMinuteRedistribution}
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='redistribucion-minuta'
                  >
                    <img
                      src={'/amd-sodexo/media/icons/minutas/arrowRepeat.svg'}
                      alt='Redistribución Minuta'
                    />
                  </a>
                  <ReactTooltip id='redistribucion-minuta' place='top' type='info' effect='solid'>
                    Redistribuir Ponderación
                  </ReactTooltip>
                </>
              )}
              {props.newTemplate && isValid('regenerar') && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='generar-nueva-plantilla'
                    onClick={props.onNewTemplate || undefined}
                  >
                    <img src={'/amd-sodexo/media/icons/minutas/biBack.svg'} alt='Regenerar Plantilla' />
                  </a>
                  <ReactTooltip id='generar-nueva-plantilla' place='top' type='info' effect='solid'>
                    {props.textNewTemplate ? props.textNewTemplate : 'Regenerar Plantilla'}
                  </ReactTooltip>
                </>
              )}
              {
                //TODO agregar logica para mostrar solo cuando el sitio tenga seguidores
              }
              {props.showShare && isValid('btnshare') && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='Compartir'
                    onClick={props.onShare || undefined}
                  >
                    <img src={'/amd-sodexo/media/icons/minutas/share.svg'} alt='Compartir' />
                  </a>
                  <ReactTooltip id='Compartir' place='top' type='info' effect='solid'>
                    Compartir
                  </ReactTooltip>
                </>
              )}
              {props.showValidate && isValid('btnvalidar') && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='Validar'
                    onClick={props.onValidate || undefined}
                  >
                    <img
                      src={'/amd-sodexo/media/icons/minutas/check2Square.svg'}
                      alt='Validar'
                    />
                  </a>
                  <ReactTooltip id='Validar' place='top' type='info' effect='solid'>
                    Validar
                  </ReactTooltip>
                </>
              )}

              {props.showApprove && isValid('btnaprobar') && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='aprobar'
                    onClick={props.onApprove || undefined}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='30'
                      height='30'
                      fill='#2A2889'
                      className='bi bi-check'
                      viewBox='0 0 16 16'
                    >
                      <path d='M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z' />
                    </svg>
                  </a>
                  <ReactTooltip id='aprobar' place='top' type='info' effect='solid'>
                    Aprobar
                  </ReactTooltip>
                </>
              )}

              {props.showApproveDetail && isValid('btnaprobardetalle') && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='aprobar-detalle'
                    onClick={props.onApproveDetail || undefined}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='30'
                      height='30'
                      fill='#2A2889'
                      className='bi bi-check'
                      viewBox='0 0 16 16'
                    >
                      <path d='M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z' />
                    </svg>
                  </a>
                  <ReactTooltip id='aprobar-detalle' place='top' type='info' effect='solid'>
                    Detalle Aprobacion
                  </ReactTooltip>
                </>
              )}

              {props.showDelete && isValid('btndelete') && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='delete'
                    onClick={props.onDelete || undefined}
                  >
                    <img src={'/amd-sodexo/media/icons/minutas/trash3.svg'} alt='Eliminar' />
                  </a>
                  <ReactTooltip id='delete' place='top' type='error' effect='solid'>
                    Eliminar
                  </ReactTooltip>
                </>
              )}
              {props.createMinute && (
                <>
                  <a
                    className='btn btn-secondary btn-sm'
                    href='#'
                    data-tip
                    data-for='create-minute'
                    onClick={props.onCreateMinute || undefined}
                  >
                   <img src={'/amd-sodexo/media/icons/minutas/homologate.svg'} alt="Crear" />
                  </a>
                  <ReactTooltip id='create-minute' place='top' type='error' effect='solid'>
                    Crear minuta
                  </ReactTooltip>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export {HeadLunchGrid}
